import { useQuery } from '@tanstack/react-query';
import { apiBlob } from './api';
import { loadThumb, saveThumb } from './native';

/** Thumbnails are cached on the device (mobile) so cards still show photos offline. */
async function fetchPhoto(photoId: string, size: 'full' | '256'): Promise<Blob> {
  try {
    const blob = await apiBlob(`/photos/${photoId}/${size}`);
    if (size === '256') void saveThumb(photoId, blob);
    return blob;
  } catch (e) {
    if (size === '256' && e instanceof TypeError) {
      const cached = await loadThumb(photoId);
      if (cached) return (await fetch(cached)).blob();
    }
    throw e;
  }
}

/** Blob URL for a member-only photo. Photo ids never change content, so it is cached forever. */
export function usePhotoSrc(photoId: string | null | undefined, size: 'full' | '256', override?: string | null) {
  const q = useQuery({
    queryKey: ['photo', photoId, size],
    queryFn: async () => URL.createObjectURL(await fetchPhoto(photoId!, size)),
    enabled: Boolean(photoId) && !override,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return override ?? q.data ?? null;
}
